import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { CustomValidatorsService } from '../services/custom-validators.service';
import { AuthGuard } from '../services/auth.guard';
import { Router } from '@angular/router';
import { LanguageService } from '../services/language.service';
import { ThemeService } from '../services/theme.service';

@Component({
  standalone: false,
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  resetPassForm: any;
  variables: any;
  tenantLogoUrl: string | null = null;

  invalidPass = false;

  constructor(
    private fb: FormBuilder,
    private customValidatorsService: CustomValidatorsService,
    private languageService: LanguageService,
    private themeService: ThemeService,
    private router: Router,
    private authGuard: AuthGuard,
  ) {
    this.resetPassForm = this.fb.group(
      {
        passwordCtrl: new FormControl('', [Validators.required, Validators.minLength(8)]),
        secondPasswordCtrl: new FormControl('', [Validators.required, Validators.minLength(8)]),
      },
      { validators: this.customValidatorsService.MatchValidator('passwordCtrl', 'secondPasswordCtrl') }
    )
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.themeService.branding$.subscribe(branding => {
      this.tenantLogoUrl = branding?.logo ?? null;
    });

  }


  onSubmit() {

    if (this.resetPassForm.valid) {
      this.authGuard.sendNewPassword(this.resetPassForm.value.secondPasswordCtrl).subscribe(
        (response) => {

          this.authGuard.clearToken()
          this.router.navigate(['/login']);

        },
        (error) => {
          console.error('Error resetting password', error);
          // Handle error response
        }
      );
    } else {
      if (this.resetPassForm.value.secondPasswordCtrl.length < 8 && this.resetPassForm.value.passwordCtrl.length < 8) {
        this.invalidPass = true;
      }
    }
  }

}
